import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import useWindowDimensions, { humanReadable } from "../../utils/useWindowDimensions";

const ActiveHours = ({ data, Dashboard }) => {
  let { width } = useWindowDimensions();

  function secondsToHHMM(seconds) {
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);

    var hourString = hours === 1 ? "Hr" : "Hrs";
    var minuteString = minutes === 1 ? "Min" : "Mins";

    var formattedTime = "";

    if (hours > 0) {
      formattedTime += hours + " " + hourString;
      if (minutes > 0) {
        formattedTime += " ";
      }
    }

    if (minutes > 0) {
      formattedTime += minutes + " " + minuteString;
    }

    return formattedTime;
  }

  let chart = {
    series: [
      {
        name: "Time Spent (≈)",
        data: data.map((e) => e.avg) || [],
      },
    ],
    options: {
      chart: {
        type: "line",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.6,
          stops: [0, 100],
        },
      },
      grid: {
        row: {
          colors: ["transparent", "transparent"],
          opacity: 0.5,
          // smoothing: 10
        },
      },
      xaxis: {
        categories: data.map((e) => e.label) || [],
      },
      yaxis: {
        min: 0,
        labels: {
          formatter: function (value) {
            return Math.round(value / 3600);
          },
        },
      },
      tooltip: {
        y: {
          formatter: function (value) {
            return secondsToHHMM(value);
          },
        },
      },
      colors: ["#333333"],
    },
  };

  return (
    <>
      <div id="chart">
        <ReactApexChart
          options={chart.options}
          series={chart.series}
          type="area"
          height={
            Dashboard === "team"
              ? width > 1400 && width < 1700
                ? 235
                : width >= 1700
                ? 280
                : 185
              : width > 1400 && width < 1700
              ? 235
              : width >= 1700
              ? 300
              : 185
          }
        />
      </div>
    </>
  );
};

export default ActiveHours;
